type PieTimerProps = {
  active: boolean
  startColor: string
  endColor: string
  percentage: number
}

// moves counter clockwise from 100% to 0%
export const PieTimer = ({
  active,
  startColor,
  endColor,
  percentage,
}: PieTimerProps) => {
  const radius = 4.5
  const circumference = 2 * Math.PI * radius
  const strokeDasharray = `${
    ((100 - percentage) / 100) * circumference
  } ${circumference}`

  return (
    <div
      className={`inset-0 aspect-square h-3 w-3 ${active ? '' : 'opacity-0'}`}
      style={{
        opacity: active ? 1 : 0,
      }}
    >
      <svg
        width="12"
        height="12"
        className="-rotate-90 transform overflow-hidden rounded-full"
      >
        <circle cx="6" cy="6" r="6" fill={startColor} />
        <circle
          cx="6"
          cy="6"
          r={radius}
          fill="none"
          stroke={endColor}
          strokeWidth="9"
          strokeDasharray={strokeDasharray}
          className="transition-all duration-500 ease-linear"
          style={{
            transformOrigin: 'center',
          }}
        />
      </svg>
    </div>
  )
}
